const EngagementSection = () => {
  return (
    <section id="engagement" className="py-20 sm:py-32 px-6 bg-[#cfb8a9]">
      <div className="max-w-2xl mx-auto text-center text-[#3F2A24]">

        {/* En-tête */}
        <div className="space-y-4 mb-16">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#F9F0E0]">
            Le passage
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl">
            Engagement
          </h2>
        </div>

        <div className="space-y-14 font-serif text-base sm:text-lg leading-[2.2] text-[#3F2A24]/80">

          <p>
            COCON n'a jamais été conçu pour séduire.
            <br />Il a été pensé comme un seuil.
          </p>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          <div className="space-y-4">
            <p className="font-medium text-[#3F2A24]">COCON est un cycle.</p>
            <p>Un cycle initiatique contemporain.</p>
            <p className="italic">Incarné.</p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          <div className="space-y-2">
            <p>Pas un moment.</p>
            <p className="font-medium text-[#3F2A24]">Un mouvement.</p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          {/* Avant */}
          <div className="space-y-4">
            <p className="text-xs tracking-[0.25em] uppercase text-[#F3E5CF] font-medium">Avant</p>
            <p>Le lien commence avant l'arrivée.</p>
            <p>
              Un espace s'ouvre.
              <br />Progressivement.
            </p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          {/* Pendant */}
          <div className="space-y-4">
            <p className="text-xs tracking-[0.25em] uppercase text-[#F3E5CF] font-medium">Pendant</p>
            <p className="font-medium text-[#3F2A24]">Valouse.</p>
            <p>
              Un lieu retiré.
              <br />Entièrement habité.
            </p>
            <p>
              Quelques jours hors du rythme habituel.
              <br />Un cercle restreint.
              <br />Présent.
            </p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          {/* Après */}
          <div className="space-y-4">
            <p className="text-xs tracking-[0.25em] uppercase text-[#F3E5CF] font-medium">Après</p>
            <p>Rien ne s'arrête en repartant.</p>
            <p>
              Ce qui a été touché
              <br />continue.
            </p>
            <p>
              S'intègre.
              <br />S'incarne.
            </p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          <div className="space-y-4">
            <p>L'immersion n'est pas un événement.</p>
            <p className="font-medium text-[#3F2A24]">C'est un centre.</p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          <p>
            Autour, tout s'organise.
            <br />Avant. Pendant. Après.
          </p>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          <div className="space-y-4">
            <p>Peu de places.</p>
            <p>Non par contrainte.</p>
            <p className="font-medium text-[#3F2A24] italic">Par exigence.</p>
          </div>

          <div className="w-10 h-[1px] bg-[#C5A059]/50 mx-auto" />

          <div className="space-y-2">
            <p>Pour préserver :</p>
            <p>
              le lien,
              <br />la présence,
              <br />et la qualité de ce qui peut réellement se vivre.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default EngagementSection;
